// Country calling codes for phone inputs. `id` is the ISO country code (unique
// even where countries share a dial code, e.g. US and Canada).
export const DIAL_CODES = [
  { id: "US", name: "United States", code: "+1" },
  { id: "CA", name: "Canada", code: "+1" },
  { id: "MX", name: "Mexico", code: "+52" },
  { id: "GB", name: "United Kingdom", code: "+44" },
  { id: "IE", name: "Ireland", code: "+353" },
  { id: "AU", name: "Australia", code: "+61" },
  { id: "NZ", name: "New Zealand", code: "+64" },
  { id: "AR", name: "Argentina", code: "+54" },
  { id: "AT", name: "Austria", code: "+43" },
  { id: "BS", name: "Bahamas", code: "+1" },
  { id: "BE", name: "Belgium", code: "+32" },
  { id: "BR", name: "Brazil", code: "+55" },
  { id: "CL", name: "Chile", code: "+56" },
  { id: "CO", name: "Colombia", code: "+57" },
  { id: "CR", name: "Costa Rica", code: "+506" },
  { id: "HR", name: "Croatia", code: "+385" },
  { id: "DK", name: "Denmark", code: "+45" },
  { id: "DO", name: "Dominican Republic", code: "+1" },
  { id: "FI", name: "Finland", code: "+358" },
  { id: "FR", name: "France", code: "+33" },
  { id: "DE", name: "Germany", code: "+49" },
  { id: "GR", name: "Greece", code: "+30" },
  { id: "IS", name: "Iceland", code: "+354" },
  { id: "IN", name: "India", code: "+91" },
  { id: "ID", name: "Indonesia", code: "+62" },
  { id: "IL", name: "Israel", code: "+972" },
  { id: "IT", name: "Italy", code: "+39" },
  { id: "JM", name: "Jamaica", code: "+1" },
  { id: "JP", name: "Japan", code: "+81" },
  { id: "MY", name: "Malaysia", code: "+60" },
  { id: "MA", name: "Morocco", code: "+212" },
  { id: "NL", name: "Netherlands", code: "+31" },
  { id: "NO", name: "Norway", code: "+47" },
  { id: "PA", name: "Panama", code: "+507" },
  { id: "PE", name: "Peru", code: "+51" },
  { id: "PH", name: "Philippines", code: "+63" },
  { id: "PL", name: "Poland", code: "+48" },
  { id: "PT", name: "Portugal", code: "+351" },
  { id: "PR", name: "Puerto Rico", code: "+1" },
  { id: "SG", name: "Singapore", code: "+65" },
  { id: "ZA", name: "South Africa", code: "+27" },
  { id: "KR", name: "South Korea", code: "+82" },
  { id: "ES", name: "Spain", code: "+34" },
  { id: "SE", name: "Sweden", code: "+46" },
  { id: "CH", name: "Switzerland", code: "+41" },
  { id: "TH", name: "Thailand", code: "+66" },
  { id: "TR", name: "Türkiye", code: "+90" },
  { id: "AE", name: "United Arab Emirates", code: "+971" },
  { id: "VN", name: "Vietnam", code: "+84" },
];

export const dialCodeFor = (id) => DIAL_CODES.find((c) => c.id === id)?.code || "+1";
